<template>
  <div inline>
    <div
      class="ability--head"
      v-bind:class="type.Name"
      style="width: 100%">
      <img
        v-if="type.HasIcon"
        :src="type.Icon"
        style="height: 1.5em; padding-right: 0.25em; margin-bottom: -0.25em" />
      <display-tooltip-text :string="type.Name" />
    </div>
    <div class="card--content">
      <div
        v-if="type.Desc.length > 0"
        style="font-style: italic">
        {{ type.Desc }}<br />
      </div>
      <div
        class="chart--wrapper"
        inline>
        <v-row
          no-gutters
          class="chart--row">
          <v-col
            class="chart--head"
            cols="2">
            <display-tooltip-text
              string="_Phase_"
              :decorate="false" />
          </v-col>
          <v-col
            class="chart--head"
            cols="2">
            <display-tooltip-text
              string="_Stamina_"
              :decorate="false" />
          </v-col>
          <v-col
            class="chart--head"
            cols="2">
            <display-tooltip-text
              string="_Guard_"
              :decorate="false" />
          </v-col>
          <v-col
            class="chart--head"
            cols="2">
            <display-tooltip-text
              string="_Speed_"
              :decorate="false" />
          </v-col>
          <v-col
            class="chart--head"
            cols="2">
            <display-tooltip-text
              string="_Block_"
              :decorate="false" />
          </v-col>
        </v-row>
        <v-row
          align="stretch"
          no-gutters
          class="chart--row"
          style="border-top: none">
          <v-col
            class="chart--cols justify-center align-center"
            cols="2"
            >{{ type.Phase }}</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            cols="2"
            >{{ type.Stamina }}</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            cols="2">
            {{ type.Guard }}</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            cols="2"
            >{{ type.Speed }}</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            cols="2"
            >{{ type.Block }}</v-col
          >
        </v-row>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { SpiritType } from '@/class'
import BasicTable from '@/components/BasicTable.vue'

export default Vue.extend({
  name: 'spirit-type-card',
  props: {
    type: {
      type: SpiritType,
      required: true,
    },
  },
  components: { BasicTable },
})
</script>

<style scoped lang="scss">
.a {
}
</style>
